import React, { useState } from 'react';
import { Modal, Button, message } from 'antd';
import { deleteFolder, deleteFolderElement } from '../../utils/services/folderAPI';
import { ModalBody, Container } from './styles';
import { useTranslation } from 'react-i18next';
import { DESIGN_AREA_FOLDERS_TAB } from '../../containers/SidebarMenu/translationValues';

const NAMESPACES = ['DESIGN_AREA_FOLDERS_TAB']
const DeleteFolderModal = props => {
  const { visible, onCancel, target, removeTemplate, folderName } = props;
  const { t } = useTranslation(NAMESPACES);
  const [deleting, setDeleting] = useState(false);
  const onDelete = async () => {
    let response;
    const payload = {
      id: target?.id || target?.parentBlockId,
    };
    setDeleting(true);
    if (removeTemplate) {
      response = await deleteFolderElement(payload);
    } else {
      response = await deleteFolder(payload);
    }
    if (response) {
      setDeleting(false);
      if (response && response.errors && response.errors.length === 0) {
        const responseType = removeTemplate ? 'Template deleted successfully' : 'folder deleted successfully';
        removeTemplate
          ? message.success(t(DESIGN_AREA_FOLDERS_TAB.TEMPLATE_REMOVED_SUCCESS_MESSAGE.key, DESIGN_AREA_FOLDERS_TAB.TEMPLATE_REMOVED_SUCCESS_MESSAGE.value))
          : message.success(t(DESIGN_AREA_FOLDERS_TAB.FOLDER_DELETED_SUCCESS_MESSAGE.key, DESIGN_AREA_FOLDERS_TAB.FOLDER_DELETED_SUCCESS_MESSAGE.value));
        onCancel(responseType, response.id, payload);
      }
    }
  };

  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      onDelete();
    }
  };

  return (
    <Container onKeyDown={e => e.stopPropagation()} onKeyPress={handleKeyPress}>
      <Modal
        title={removeTemplate ? t(DESIGN_AREA_FOLDERS_TAB.REMOVE_TEMPLATE_MODAL_TITLE.key, DESIGN_AREA_FOLDERS_TAB.REMOVE_TEMPLATE_MODAL_TITLE.value) : t(DESIGN_AREA_FOLDERS_TAB.DELETE_FOLDER_MODAL_TITLE.key, DESIGN_AREA_FOLDERS_TAB.DELETE_FOLDER_MODAL_TITLE.value)}
        centered
        visible={visible}
        width="625px"
        onCancel={onCancel}
        footer={[
          <Button key="back" onClick={onCancel}>
            {t(DESIGN_AREA_FOLDERS_TAB.CANCEL_DELETE_FOLDER_BUTTON.key, DESIGN_AREA_FOLDERS_TAB.CANCEL_DELETE_FOLDER_BUTTON.value)}
          </Button>,
          <Button key="submit" type="primary" loading={deleting} onClick={onDelete}>
            {removeTemplate
              ? deleting
                ? t(DESIGN_AREA_FOLDERS_TAB.REMOVING_BUTTON.key, DESIGN_AREA_FOLDERS_TAB.REMOVING_BUTTON.value)
                : t(DESIGN_AREA_FOLDERS_TAB.REMOVE_TEMPLATE_BUTTON.key, DESIGN_AREA_FOLDERS_TAB.REMOVE_TEMPLATE_BUTTON.value)
              : deleting
              ?  t(DESIGN_AREA_FOLDERS_TAB.DELETING_FOLDER_BUTTON.key, DESIGN_AREA_FOLDERS_TAB.DELETING_FOLDER_BUTTON.value)
              :  t(DESIGN_AREA_FOLDERS_TAB.DELETE_FOLDER_BUTTON.key, DESIGN_AREA_FOLDERS_TAB.DELETE_FOLDER_BUTTON.value)}
          </Button>,
        ]}
        className="warning-modal"
      >
        <ModalBody>
          <div className="warning-text">
          <span>
              {t(
                DESIGN_AREA_FOLDERS_TAB.FOLDER_DELETE_CONFIRMATION.key,
                DESIGN_AREA_FOLDERS_TAB.FOLDER_DELETE_CONFIRMATION.value,
              ) + ' '}{' '}
              {removeTemplate
                ? t(DESIGN_AREA_FOLDERS_TAB.REMOVE_TEMPLATE.key, DESIGN_AREA_FOLDERS_TAB.REMOVE_TEMPLATE.value)
                : t(DESIGN_AREA_FOLDERS_TAB.DELETE_FOLDER.key, DESIGN_AREA_FOLDERS_TAB.DELETE_FOLDER.value)}
            </span>
            {target && target.name && <span className="text-highlighter">{target.name}</span>}
            <span>
              {removeTemplate
                ? t(DESIGN_AREA_FOLDERS_TAB.REMOVE_TEMPLATE_NAME.key, DESIGN_AREA_FOLDERS_TAB.REMOVE_TEMPLATE_NAME.value)
                : t(DESIGN_AREA_FOLDERS_TAB.DELETE_FOLDER_NAME.key, DESIGN_AREA_FOLDERS_TAB.DELETE_FOLDER_NAME.value)}
            </span>{' '}
            {removeTemplate ? (
              ''
            ) : (
              <span>
                {t(DESIGN_AREA_FOLDERS_TAB.FOLDER_HAVE.key, DESIGN_AREA_FOLDERS_TAB.FOLDER_HAVE.value)}{' '}
                <span className="text-highlighter">{target.subFolder.length} {t(DESIGN_AREA_FOLDERS_TAB.SUB_FOLDERS_COUNT_LABEL.key, DESIGN_AREA_FOLDERS_TAB.SUB_FOLDERS_COUNT_LABEL.value)}</span>and{' '}
                <span className="text-highlighter">{target.elements.length} {t(DESIGN_AREA_FOLDERS_TAB.TEMPLATES_COUNT_LABEL.key, DESIGN_AREA_FOLDERS_TAB.TEMPLATES_COUNT_LABEL.value)}.</span>
              </span>
            )}
            {removeTemplate ? (
              <span>
                {t(DESIGN_AREA_FOLDERS_TAB.FOLDER_UNDER.key, DESIGN_AREA_FOLDERS_TAB.FOLDER_UNDER.value)}
                <span className="text-highlighter"> {folderName} </span>
                {t(DESIGN_AREA_FOLDERS_TAB.DELETE_FOLDER_NAME.key, DESIGN_AREA_FOLDERS_TAB.DELETE_FOLDER_NAME.value)}
              </span>
            ) : (
              ''
            )}
          </div>
        </ModalBody>
      </Modal>
    </Container>
  );
};
export default DeleteFolderModal;
